import ENV from "../env";
import redirectToTopLevel from "./redirectToTopLevel";

const createStripePayment = async (
  amount,
  tickets,
  details,
  customerEmail,
  orgId,
  eventId,
  paymentMethod,
  feeDelegated,
  subdivision,
  promoCodeId = null,
  promoCodeUsageIncrement = 0,
) => {
  const response = await fetch(`${ENV.firebaseApiUrl}/stripe/create-checkout-session`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      amount: amount,
      eventId,
      tickets,
      details,
      customerEmail,
      paymentMethod,
      feeDelegated,
      orgId,
      checkoutUrl: `${ENV.hostname}/checkout/${eventId}`,
      subdivision,
      promoCodeId,
      promoCodeUsageIncrement,
    }),
  });

  const resData = await response.json();
  if (!response.ok) {
    const errorMessage = resData?.error || resData?.message || "Unknown error";
    throw Object.assign(new Error("Paiement échoué: " + errorMessage), { code: resData.code, max: resData.max, ticketName: resData.ticketName, items: resData.items });
  }

  const session = resData.session;

  redirectToTopLevel(session.url);
};

export default createStripePayment;
